import CloseIcon from "@mui/icons-material/Close";
import { Alert } from "@mui/lab";
import { Box, Button, IconButton, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { MESApiService } from "../../services";
import { AuthContext } from "../AuthContext";
import { WindowsLogo } from "./windows";

export const LoginWithWindowsAuthentication = () => {
	const [showError, setShowError] = React.useState(false);
	const [error, setError] = React.useState<any>(undefined);
	const { saveUserData } = React.useContext(AuthContext);

	const [windowsAuthIsEnabled, setWindowsAuthIsEnabled] = useState(false);

	const checkIfEnabled = async () => {
		const apiService = new MESApiService();
		const response = await apiService.checkIfWindowsAuthIsEnabled();
		if (apiService.hasErrors) {
			setShowError(true);
			setError(apiService.error);
		} else {
			setWindowsAuthIsEnabled(response ?? false);
		}
	};

	const login = useCallback(
		async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
			const apiService = new MESApiService();
			e.preventDefault();
			try {
				const response = await apiService.loginWithWindowsAuthentication();
				const data = await response.json();
				saveUserData(data);
			} catch (e: any) {
				setShowError(true);
				setError(e.toString());
			}
		},
		[setShowError, setError, saveUserData],
	);

	const handleCloseError = () => {
		setShowError(false);
		setError(undefined);
	};

	useEffect(() => {
		checkIfEnabled().then(() => {});
	}, []);

	if (windowsAuthIsEnabled)
		return (
			<>
				{showError && (
					<Box
						sx={{
							marginBottom: (theme) => theme.spacing(2),
						}}
					>
						<Alert
							severity="error"
							variant="filled"
							onClose={handleCloseError}
							action={
								<IconButton
									size="small"
									aria-label="close"
									color="inherit"
									onClick={handleCloseError}
								>
									<CloseIcon fontSize="small" />
								</IconButton>
							}
						>
							<Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
								Bad credentials
							</Typography>
							<Typography variant="body2">{error}</Typography>
						</Alert>
					</Box>
				)}
				<Button
					fullWidth
					variant="outlined"
					color="primary"
					sx={{
						padding: (theme) => theme.spacing(1.2),
						fontWeight: 600,
						transition: "all 0.3s ease",
						"&:hover": {
							transform: "translateY(-2px)",
							boxShadow: (theme) => theme.shadows[4],
						},
					}}
					role="button"
					onClick={login}
					startIcon={<WindowsLogo />}
				>
					Windows Authentication
				</Button>
			</>
		);
	return null;
};
